<template>
  <div>
    <div
      v-for="(parkingBooking, index) in parkingBookings"
      :key="parkingBooking.parkingBookingID"
    >
      <v-container class="purple white--text">
        <h4>Parking {{ index + 1 }}</h4>
      </v-container>
      <!-- start parkingbooking content -->
      <v-card-item>
        <template slot="title">
          {{ parkingBooking.parkingName }}
        </template>
        <template slot="actions">
          <IconButton
            icon="fa-times-circle"
            tooltip="Delete Reservation"
            color="red"
            @click="deleteCartParkingBooking({parkingBookingID: parkingBooking.parkingBookingID})"
          />
        </template>
        <template>
          <v-layout row>
            <v-flex xs8>
              <strong>Date:</strong> {{ parkingBooking.reservedDate }}<br>
              <strong>Vehicle:</strong> {{ parkingBooking.vehicleMake }} -  {{ parkingBooking.vehicleModel }}
            </v-flex>
            <v-flex>
              <strong>Price:</strong> ${{ parkingBooking.price }}
            </v-flex>
          </v-layout>
        </template>
      </v-card-item>
      <v-card-item v-if="!assignedGatePasses[parkingBooking.parkingBookingID]">
        <v-layout justify-center>
          <v-btn
            round
            color="primary"
            dark
            @click="createGatePass({parkingBookingID: parkingBooking.parkingBookingID})"
          >
            Add a non-resident gate pass
          </v-btn>
        </v-layout>
      </v-card-item>
      <GatePasses :parking-booking="parkingBooking.parkingBookingID"/>
      <!-- end parking booking content -->
    </div>
  </div>
</template>

<script>
// import vuex mapping
import { mapGetters, mapActions } from 'vuex'
import GatePasses from './GatePasses'

export default {
  components: {
    GatePasses
  },
  computed: {
    ...mapGetters({
      parkingBookings: 'cart/parkingBookings',
      parkingAreas: 'facilities/parkingAreas',
      personSettings: 'person/settings',
      gatePasses: 'cart/gatePasses'
    }),
    assignedGatePasses () {
      return this.gatePasses.filter((gatePass) => gatePass.parkingBookingID != null).reduce((formatted, gatePass) => {
        formatted[gatePass.parkingBookingID] = gatePass
        return formatted
      }, {})
    }
  },
  methods: {
    ...mapActions({
      deleteCartParkingBooking: 'cart/deleteCartParkingBooking',
      createGatePass: 'cart/createGatePass'
    })
  }
}
</script>
